import { PATHS, QUERY_PARAMS } from "constants/routing";

export const CLAIMS_SUB_MENU = [
  {
    title: "Medical",
    path: PATHS.CLAIMS_MEDICAL_CLINICAL,
    basePath: PATHS.CLAIMS_MEDICAL,
    persistQueryParams: true,
    hidden: false
  },
  {
    title: "Program Partners",
    path: PATHS.CLAIMS_PARTNERS,
    persistQueryParams: true,
    hidden: true
  },
  {
    title: "Rx",
    path: PATHS.CLAIMS_RX,
    persistQueryParams: true,
    hidden: false
  },
  {
    title: "High Cost Claimants",
    path: PATHS.CLAIMS_HIGH_COST,
    persistQueryParams: true,
    hidden: false
  },
  {
    title: "Dental",
    path: PATHS.CLAIMS_DENTAL,
    persistQueryParams: true,
    hidden: true
  },
  {
    title: "Vision",
    path: PATHS.CLAIMS_VISION,
    persistQueryParams: true,
    hidden: true
  },
  {
    title: "Enrollment Summary",
    path: PATHS.CLAIMS_ENROLLMENT_SUMMARY,
    persistQueryParams: false,
    hidden: true
  }
];

/**
 * MENU ITEMS
 *
 * List of all the static menu items that can be displayed in the sidebar.
 *
 */
export const MENU_ITEMS = {
  [PATHS.ACCOUNT]: {
    title: "Account",
    path: PATHS.ACCOUNT,
    hasDivider: true
  },
  [PATHS.CLAIMS]: {
    title: "Claims",
    subtitle: "Analytics",
    path: PATHS.CLAIMS,
    subMenuItems: CLAIMS_SUB_MENU
  },
  [PATHS.DOCUMENTS]: {
    title: "Documents",
    path: PATHS.DOCUMENTS
  },
  [PATHS.LOGOUT]: {
    title: "Logout",
    path: PATHS.LOGOUT,
    search: `?${QUERY_PARAMS.TRACK_LOGOUT}=true`
  },
  [PATHS.PEOPLE]: {
    title: "People",
    path: PATHS.PEOPLE
  },
  [PATHS.ANALYTICS]: {
    title: "Analytics",
    path: PATHS.ANALYTICS,
    supportLabel: true,
    hasExternalLinkIcon: true
  }
};

/**
 * DEFAULT MENU ITEMS
 *
 * Ordered list of the menu items displayed in the Sidebar by default.
 *
 */
export const DEFAULT_MENU_ITEMS = [
  MENU_ITEMS[PATHS.PEOPLE],
  MENU_ITEMS[PATHS.CLAIMS],
  MENU_ITEMS[PATHS.DOCUMENTS],
  MENU_ITEMS[PATHS.ANALYTICS],
  MENU_ITEMS[PATHS.ACCOUNT],
  MENU_ITEMS[PATHS.LOGOUT]
];
